<template>
  <section class="app-main">
    <Tags @tagChange="tagChange" />
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachePaths">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import Tags from "./Tags.vue";

// import { mapGetters, mapMutations } from "vuex";
export default {
  name: "AppMain",
  components: { Tags },
  data() {
    return {
      cachePaths: [],
    };
  },
  computed: {
    // ...mapGetters(["taglistNew"]),
  },
  methods: {
    tagChange(list) {
      // tagChange() {
      const cachePaths = [];
      list.forEach((item) => {
        if (item.name && !cachePaths.includes(item.name)) {
          cachePaths.push(item.name);
        }
      });
      this.cachePaths = cachePaths;
    },
  },
};
</script>
<style scoped>
/* .app-main >>> .el-tabs {
  box-shadow: none;
  border-bottom: none;
}
.app-main >>> .el-tabs__content {
  padding: 0;
} */
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue